// src/layouts/Pages/PageHeader/CardHeaderColumns/items/cnae.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { AuditOutlined, FileTextOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';
import { returnOnlyNumbers } from 'utils/helpers';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const cnaeItem = record => {
  const cnae = record?.fiscalData?.mainCnae;

  return {
    key: 'cnae',
    icon: <FileTextOutlined />,
    label: cnae || translateX('n_a'),
    tooltipText: translateX('cnae_tooltip'),
    tooltipPlacement: 'right',
    onClick: cnae
      ? () => appService.handleCopyToClipboard(returnOnlyNumbers(cnae), 'cnae_copied')
      : null,
  };
};

export default cnaeItem;
